/**
 * Block default payloads — isolated from metadata and render graph.
 */
import { CARD_BLOCK_DEFAULTS } from '../Blocks/shared/defaults/card-defaults'
import { SUPPORTING_NOTES_BLOCK_DEFAULTS } from '../Blocks/shared/defaults/supporting-notes-defaults'
import { HERO_BLOCK_DEFAULTS } from '../Blocks/shared/defaults/hero-defaults'
import {
  BADGE_BLOCK_DEFAULTS,
  CALLOUT_BLOCK_DEFAULTS,
  INSIGHT_BLOCK_DEFAULTS,
  INTERVIEWER_TEST_DEFAULTS,
  QUOTE_BLOCK_DEFAULTS,
  CODE_BLOCK_DEFAULTS,
  MEDIA_BLOCK_DEFAULTS,
  QUESTION_BLOCK_DEFAULTS,
  REFERENCE_BLOCK_DEFAULTS,
  RICHTEXT_BLOCK_DEFAULTS,
  RULE_BLOCK_DEFAULTS,
  STEPS_BLOCK_DEFAULTS,
  SUMMARY_BLOCK_DEFAULTS,
  TIMELINE_BLOCK_DEFAULTS,
  WARNING_BOX_DEFAULTS,
  ZONE_GRID_DEFAULTS,
  DAILY_ROW_DEFAULTS,
  STEP_ROW_DEFAULTS,
} from '../Blocks/shared/defaults/block-seeds'
import { createEmptyTabsBlockData } from '../models/tabs-model'
import { resolveBlockType } from './blocks-registry-resolve'

const BLOCK_DEFAULTS_BY_TYPE = {
  block_card: CARD_BLOCK_DEFAULTS,
  block_supporting_notes: SUPPORTING_NOTES_BLOCK_DEFAULTS,
  block_badge: BADGE_BLOCK_DEFAULTS,
  block_callout: CALLOUT_BLOCK_DEFAULTS,
  block_quote: QUOTE_BLOCK_DEFAULTS,
  block_code: CODE_BLOCK_DEFAULTS,
  block_media: MEDIA_BLOCK_DEFAULTS,
  block_rule: RULE_BLOCK_DEFAULTS,
  block_zone_grid: ZONE_GRID_DEFAULTS,
  block_warning_box: WARNING_BOX_DEFAULTS,
  block_daily_row: DAILY_ROW_DEFAULTS,
  block_step_row: STEP_ROW_DEFAULTS,
  block_steps: STEPS_BLOCK_DEFAULTS,
  block_hero: HERO_BLOCK_DEFAULTS,
  block_richtext: RICHTEXT_BLOCK_DEFAULTS,
  block_insight: INSIGHT_BLOCK_DEFAULTS,
  block_summary: SUMMARY_BLOCK_DEFAULTS,
  block_question: QUESTION_BLOCK_DEFAULTS,
  block_reference: { references: [] },
  block_timeline: TIMELINE_BLOCK_DEFAULTS,
  block_interviewer_test: INTERVIEWER_TEST_DEFAULTS,
  block_lesson_tracker: {},
}

export function getBlockDefaultData(type) {
  const resolved = resolveBlockType(type)

  if (resolved === 'block_tabs') {
    return createEmptyTabsBlockData()
  }

  const defaults = BLOCK_DEFAULTS_BY_TYPE[resolved]
  if (defaults === undefined) return {}

  return structuredClone(
    typeof defaults === 'object' && defaults !== null ? defaults : {},
  )
}
